<template lang="pug">
  shListData(title="Invoices History" resolver="invoicesHistory" keyData="_id" component="shInvoice" :history="true")
</template>

<script>
import shListData from '@/components/global/ListData'

export default {
  name: 'InvoicesHistory',

  components: { shListData }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/invoice/InvoicesHistory.vue